var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contentMrg"}},[_c('TopList',{attrs:{"navList":_vm.navList},on:{"setType":_vm.setType}}),(_vm.type === 0)?_c('All'):_c('Paper',{attrs:{"index":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }